<template>
  <section class="bottomContainer">
    <button class="button" @click="$emit('click')" :disabled="disabled">
      Continuar sem pedido médico
    </button>
  </section>
</template>

<script>
export default {
  name: 'ContinueWithoutMedicalOrderButton',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.bottomContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0;
  width: 100%;

  .button {
    width: 328px;
    height: 48px;
    background-color: #0037ff;
    color: white;
    border: none;
    border-radius: 4px;
    font-family: 'Dasa sans', sans-serif;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    text-align: center;
    justify-content: space-between;
    cursor: pointer;

    &:disabled {
      cursor: not-allowed;
      background-color: #ccc;
    }
  }
}
</style>
